export default {
    methods: {
        filterSelects(list) {
            return _.filter(this.lists[list], ['id_list_estado', 1])
        },
        async getFiltrar() {
            let dataRoute = {}
            let others = []
            let filterKeys = Object.keys(this.filter);
            for (let i = 0; i < filterKeys.length; i++) {
                if (filterKeys[i] === 'inicial') {
                    (this.filter.inicial === '') ? dataRoute.inicial = this.fecha().inicioLabores.servicios: dataRoute.inicial = this.filter.inicial;

                }
                if (filterKeys[i] === 'final') {
                    (this.filter.final === '') ? dataRoute.final = this.fecha().inicioLabores.servicios: dataRoute.final = this.filter.final;
                }
                if (filterKeys[i] !== 'inicial' && filterKeys[i] !== 'final' && this.filter[filterKeys[i]] !== '' && this.filter[filterKeys[i]] !== null && this.filter[filterKeys[i]].id !== undefined) {
                    others.push([filterKeys[i], this.filter[filterKeys[i]].id])
                } else if (filterKeys[i] !== 'inicial' && filterKeys[i] !== 'final' && this.filter[filterKeys[i]].compare !== undefined) {
                    others.push([filterKeys[i], this.filter[filterKeys[i]].compare, this.filter[filterKeys[i]].value])
                } else if (filterKeys[i] !== 'inicial' && filterKeys[i] !== 'final' && this.filter[filterKeys[i]].length > 0) {
                    others.push([filterKeys[i], 'like', '%' + this.filter[filterKeys[i]].join('%') + '%'])
                } else if (filterKeys[i] === 'prioridad') {
                    dataRoute.prioridad = this.filter[filterKeys[i]]
                } else if (filterKeys[i] === 'sinPrioridad') {
                    dataRoute.sinPrioridad = this.filter[filterKeys[i]]
                }
            }
            dataRoute.others = others
            await this.getDataGet({ route: 'get_archivoplano', data: dataRoute })
                //frontend await this.searchGetIdb({tabla:'afiliacion_registro', campo:'id_datos_asesor', value: this.filter.servicios.id})
        },
        async getLimpiar() {
            this.filter = {
                inicial: this.fecha().fecha.minHoy,
                final: this.fecha().fecha.minHoy,
                id_list_mes: this.gettersDatalist('list_mes', this.fecha().fecha.mesHoy)[0],
                id_list_ano: this.gettersDatalist('list_ano', this.fecha().fecha.anoHoy)[0],
                id_datos_razon: this.gettersDatalist('datos_razon', 1)[0],
                servicios: [],
                planilla: { "compare": "=", "value": null }
            }
            await this.resetDataGet()
        },
        async changeBeetwen() {
            if (this.filter.id_list_mes.id !== this.gettersDatalist('list_mes', this.fecha().fecha.mesHoy)[0].id || this.filter.id_list_ano.id !== this.gettersDatalist('list_ano', this.fecha().fecha.anoHoy)[0].id) {
                this.filter.inicial = this.fecha(this.filter.id_list_ano.id + '-' + this.filter.id_list_mes.id + '-01').inicioLabores.servicios
                this.filter.final = this.fecha(this.filter.id_list_ano.id + '-' + this.filter.id_list_mes.id + '-01').inicioLabores.servicios
            } else {
                this.filter.inicial = this.fecha().fecha.minHoy
                this.filter.final = this.fecha().fecha.minHoy
            }
            await this.resetDataGet()
        }
    },
}